var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h15v3h3.025l3.979 5.685V14h-2.657a3.252 3.252 0 0 1-6.186 0H9.256a3.251 3.251 0 0 1-6.186 0H0V0zm3.07 12a3.251 3.251 0 0 1 6.186 0H13V2H2v10h1.07zM15 10a3.252 3.252 0 0 1 4.347 2h.657V9.315L16.984 5H15v5zm-8.837 1.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm10.09 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.80544b56a2961bc53c5fbeaf86ed1777.svg";
export { ForwardRef as ReactComponent };